export default {"src":"/_next/static/media/rp-logo-mark.c70268b9.svg","height":14,"width":162};